import requestApi from "./requestApi";

export const getRelGeral = async ({ dataInicial, dataFinal, especificaId, servicoId, unidadeId, turmaId }: { dataInicial?: string; dataFinal?: string; especificaId?: string | number; servicoId?: string | number; unidadeId?: string | number; turmaId?: string | number }) => {
  let url = `Report/GetRelGeral?`;
  if (dataInicial) url += `dataInicial=${dataInicial}&`;
  if (dataFinal) url += `dataFinal=${dataFinal}&`;
  if (especificaId) url += `especificaId=${especificaId}&`;
  if (servicoId) url += `servicoId=${servicoId}&`;
  if (unidadeId) url += `unidadeId=${unidadeId}&`;
  if (turmaId) url += `turmaId=${turmaId}&`;
  url = url.replace(/&$/, "");
  try {
    const res = await requestApi.get(url);
    return res;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      window.alert("Não foram encontrado dados para o filtro informado");
    } else {
      window.alert("Erro ao consultar relatório. Por favor, consulte o suporte.");
    }
    return null;
  }
}; 

export const getListaAlunos = async ({ turmaId, especificaId, unidadeId }: { turmaId?: string; especificaId?: string; unidadeId?: string | number }) => {
  let url = `Report/ListaAlunos?`;
  if (turmaId) url += `turmaId=${turmaId}&`;
  if (especificaId) url += `especificaId=${especificaId}&`;
  if (unidadeId) url += `unidadeId=${unidadeId}&`;
  url = url.replace(/&$/, '');
  try {
    const res = await requestApi.get(url);
    return res;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      window.alert("Não foram encontrado dados para o filtro informado");
    } else {
      window.alert("Erro ao consultar relatório. Por favor, consulte o suporte.");
    }
    return { data: [] };
  }
}; 

export const getMasterSheet = async ({ unidadeIds, turmaIds }: { unidadeIds?: string; turmaIds?: string }) => {
  let url = `Report/MasterSheet?`;
  if (unidadeIds) url += `unidadeIds=${unidadeIds}&`;
  if (turmaIds) url += `turmaIds=${turmaIds}&`;
  url = url.replace(/[?&]$/, "");
  try {
    const res = await requestApi.get(url);
    return res;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      window.alert("Não foram encontrado dados para o filtro informado");
    } else {
      window.alert("Erro ao consultar relatório. Por favor, consulte o suporte.");
    }
    return { data: [] };
  }
};

export const getRelOrcamentos = async ({ dataInicial, dataFinal, unidadeIds, turmaIds }: { dataInicial: string; dataFinal: string; unidadeIds?: string; turmaIds?: string }) => {
  let url = `Report/RelOrcamentos?dataInicial=${dataInicial}&dataFinal=${dataFinal}&`;
  if (unidadeIds) url += `unidadeIds=${unidadeIds}&`;
  if (turmaIds) url += `turmaIds=${turmaIds}&`;
  url = url.replace(/&$/, "");
  try {
    const res = await requestApi.get(url);
    return res;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      window.alert("Não foram encontrado dados para o filtro informado");
    } else {
      window.alert("Erro ao consultar relatório. Por favor, consulte o suporte.");
    }
    return { data: [] };
  }
};

// Listas de Plataformas (Relatórios > Listas de Plataformas) — os três relatórios
// compartilham os mesmos filtros: unidades e turmas por lista de ids separada por vírgula.
const getListaPlataforma = async (recurso: string, { unidadeIds, turmaIds }: { unidadeIds?: string; turmaIds?: string }) => {
  let url = `Report/${recurso}?`;
  if (unidadeIds) url += `unidadeIds=${unidadeIds}&`;
  if (turmaIds) url += `turmaIds=${turmaIds}&`;
  url = url.replace(/[?&]$/, "");
  try {
    const res = await requestApi.get(url);
    return res;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      window.alert("Não foram encontrado dados para o filtro informado");
    } else {
      window.alert("Erro ao consultar relatório. Por favor, consulte o suporte.");
    }
    return { data: [] };
  }
};

export const getListaStift = async (params: { unidadeIds?: string; turmaIds?: string }) =>
  getListaPlataforma("ListaStift", params);

export const getListaTriEduc = async (params: { unidadeIds?: string; turmaIds?: string }) =>
  getListaPlataforma("ListaTriEduc", params);

export const getListaHikari = async (params: { unidadeIds?: string; turmaIds?: string }) =>
  getListaPlataforma("ListaHikari", params);

export const getDadosAlunos = async({ turmaId, especificaId }: { turmaId?: string; especificaId?: string }) => {
  let url = `Report/DadosAlunos?`;
  if (turmaId) url += `turmaId=${turmaId}&`;
  if (especificaId) url += `especificaId=${especificaId}&`;
  url = url.replace(/&$/, "");
  try {
    const res = await requestApi.get(url);
    return res;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      window.alert("Não foram encontrado dados para o filtro informado");
    } else {
      window.alert("Erro ao consultar relatório. Por favor, consulte o suporte.");
    }
    return { data: [] };
  }
};